import { useEffect, useMemo, useState } from "react";
import { Calendar, Clock, MapPin } from "lucide-react";
import { api } from "../../lib/api";
import { BrutalCard, Badge, SectionTitle } from "../../components/common/Brutal";

const CAT_COLORS = {
  ceremony: "orange",
  music: "red",
  workshop: "teal",
  wellness: "green",
};

export default function CamperSchedule() {
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    api.get("/activities").then(({ data }) => setActivities(data));
  }, []);

  const grouped = useMemo(() => {
    const m = {};
    for (const a of activities) {
      m[a.date] = m[a.date] || [];
      m[a.date].push(a);
    }
    Object.values(m).forEach((arr) => arr.sort((a, b) => a.start_time.localeCompare(b.start_time)));
    return Object.entries(m).sort(([a], [b]) => a.localeCompare(b));
  }, [activities]);

  return (
    <div className="space-y-6">
      <SectionTitle kicker="Festival Schedule" title="What’s on" />
      {grouped.map(([date, items]) => (
        <BrutalCard key={date} className="p-5" data-testid={`schedule-day-${date}`}>
          <div className="flex items-center gap-2 mb-3">
            <div className="bg-[#E5247C] text-white kf-border px-3 py-1.5 display text-xl">
              {date}
            </div>
          </div>
          <div className="space-y-3">
            {items.map((a) => (
              <div
                key={a.id}
                className="kf-border bg-[#FFF4E6] p-4 grid sm:grid-cols-[110px_1fr] gap-3"
                data-testid={`activity-${a.id}`}
              >
                <div>
                  <div className="display text-2xl">{a.start_time}</div>
                  <div className="text-xs text-[#6B4E9E] uppercase tracking-widest flex items-center gap-1">
                    <Clock className="h-3 w-3" /> – {a.end_time}
                  </div>
                </div>
                <div>
                  <div className="flex items-center gap-2 flex-wrap">
                    <h4 className="font-bold text-lg">{a.name}</h4>
                    <Badge color={CAT_COLORS[a.category] || "yellow"}>
                      {a.category}
                    </Badge>
                  </div>
                  <p className="text-sm text-[#6B4E9E] mt-1">{a.description}</p>
                  <div className="text-xs text-[#6B4E9E] mt-2 flex items-center gap-1">
                    <MapPin className="h-3 w-3" /> {a.location}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </BrutalCard>
      ))}
      {activities.length === 0 && (
        <BrutalCard className="p-8 text-center text-[#6B4E9E]">
          No activities scheduled yet.
        </BrutalCard>
      )}
    </div>
  );
}
